module.exports = __webpack_public_path__ + "images/top-gainers-black-6c435ae1.svg";